import { type Asset } from 'contentful'
import Image, { type ImageProps } from 'next/image'
import { type ComponentProps } from 'react'
import { getContentfulImageProps } from '~/utils/ContentfulHelpers/ContentfulHelpers'

import { type IReducedAsset } from '../../../types/reducedTypes'

export type ContentfulImageProps = {
  image: IReducedAsset | Asset
  style?: ImageProps['style']
  overrideValues?: {
    width?: number
    height?: number
  }
  loading?: ComponentProps<typeof Image>['loading']
  decoding?: ComponentProps<typeof Image>['decoding']
  priority?: ImageProps['priority']
}

export default function ContentfulImage({
  image,
  style,
  overrideValues = {},
  loading,
  decoding,
  priority,
}: ContentfulImageProps) {
  const contentfulImageProps = getContentfulImageProps(image, overrideValues)

  return (
    <Image
      src={contentfulImageProps.src}
      alt={contentfulImageProps.alt}
      role={contentfulImageProps.alt ? undefined : 'presentation'}
      width={contentfulImageProps.width}
      height={contentfulImageProps.height}
      style={{ ...style }}
      loading={loading}
      decoding={decoding}
      priority={priority}
    />
  )
}
